import { REMEMBER_KEY } from "../mfaSession"

export function extractIdsWithHierarchy(data) {
  return data.map((item) => {
    const result = {
      id: item.id,
      spec: item.spec,
      level: item.level,
      startTime: item.startTime,
      parentModule: item.parentModule,
      parentString: item.parentString,
    }
    if (item.subActivities && item.subActivities.length > 0) {
      result.subActivities = extractIdsWithHierarchy(item.subActivities)
    }
    return result
  })
}

const LOGIN_ATTEMPTS_KEY = "loginAttempts"
const LOCKOUT_TIME_KEY = "lockoutTime"
// The chosen server outlives a sign-in: "selectedServer" is ServerGateway's saved
// organization and "lastServerSelected" is lamp-core's (written by set_server, read
// by refresh_identity and LoginWorkflow). Wiping them brings the picker back after logout.
const SERVER_SELECTION_KEYS = ["selectedServer", "lastServerSelected"]
// REMEMBER_KEY: the browsers an administrator or researcher chose to remember (mfaSession.ts).

export function clearLocalStorageItems() {
  const cached = localStorage.getItem("cachedOptions")
  const loginAttempts = localStorage.getItem(LOGIN_ATTEMPTS_KEY) || "0"
  let lockoutTime = null
  if (typeof localStorage.getItem(LOCKOUT_TIME_KEY) != "undefined") {
    lockoutTime = localStorage.getItem(LOCKOUT_TIME_KEY)
  }
  const serverSelection = [...SERVER_SELECTION_KEYS, REMEMBER_KEY].map((key) => [key, localStorage.getItem(key)])
  localStorage.clear()
  localStorage.setItem("cachedOptions", cached)
  if (!!lockoutTime) {
    localStorage.setItem(LOCKOUT_TIME_KEY, lockoutTime)
  }
  localStorage.setItem("loginAttempts", loginAttempts)
  serverSelection.forEach(([key, value]) => {
    if (value !== null) localStorage.setItem(key, value)
  })
  sessionStorage.clear()
}
